export default {
    name: 'tszbgk',
    data() {
        return {
            // 面包屑的数据
            crumbsList:Object.freeze([{
                name:'庭审直播公开',
                key:'tszbgk'
            }]),
            // 直播法院数据
            zbList:[
                {
                    name:'最高人民法院',
                    id:'zgrmfy',
                    children:[
                        {
                            name:'最高人民法院直播回放',
                            id:'zgrmfyzbhf',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/0?courtLevel=1',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/0?courtLevel=1&catalogId=1',
                            imgUrl:''
                        }
                    ]
                },
                {
                    name:'高级人民法院',
                    id:'gjrmfy',
                    children:[
                        {
                            name:'上海市高级人民法院直播回放',
                            id:'gdsrmfy1',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1100?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1100?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'江苏省高级人民法院直播回放',
                            id:'gdsrmfy2',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1150?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1150?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'广东省高级人民法院直播回放',
                            id:'gdsrmfy3',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2550?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2550?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'海南省高级人民法院直播回放',
                            id:'gdsrmfy4',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2900?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2900?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'湖北省高级人民法院直播回放',
                            id:'gdsrmfy5',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2250?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2250?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'辽宁省高级人民法院直播回放',
                            id:'gdsrmfy6',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/600?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/600?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'广西壮族自治区高级人民法院直播回放',
                            id:'gdsrmfy7',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2750?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2750?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'福建省高级人民法院直播回放',
                            id:'gdsrmfy8',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1600?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1600?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'浙江省高级人民法院直播回放',
                            id:'gdsrmfy9',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1300?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1300?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'山东省高级人民法院直播回放',
                            id:'gdsrmfy10',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1850?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1850?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'天津市高级人民法院直播回放',
                            id:'gdsrmfy11',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/51?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/51?courtLevel=2&catalogId=1',
                            imgUrl:''
                        }
                    ]
                },
                {
                    name:'海事法院',
                    id:'hsfy',
                    children:[
                        {
                            name:'上海海事法院直播回放',
                            id:'hsfy1',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1129?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1129?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'南京海事法院直播回放',
                            id:'hsfy2',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/5037?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/5037?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'广州海事法院直播回放',
                            id:'hsfy3',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2701?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2701?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'海口海事法院直播回放',
                            id:'hsfy4',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2925?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2925?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'武汉海事法院直播回放',
                            id:'hsfy5',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2367?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2367?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'大连海事法院直播回放',
                            id:'hsfy6',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/732?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/732?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'北海海事法院直播回放',
                            id:'hsfy7',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2878?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/2878?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'厦门海事法院直播回放',
                            id:'hsfy8',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1693?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1693?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'宁波海事法院直播回放',
                            id:'hsfy9',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/1402?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/1300?courtLevel=2&catalogId=1',
                            imgUrl:''
                        },
                        {
                            name:'青岛海事法院直播回放',
                            id:'hsfy10',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/2010?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/live/2010?courtLevel=2',
                            imgUrl:''
                        },
                        {
                            name:'天津海事法院直播回放',
                            id:'hsfy11',
                            liveAddr: 'http://tingshen.court.gov.cn/court/live/72?courtLevel=2',
                            replayAddr: 'http://tingshen.court.gov.cn/court/review/72?courtLevel=2&catalogId=1',
                            imgUrl:''
                        }
                    ]
                }
            ]
        };
    },
    methods: {
        viewLive(url) {
            window.open(url, '_blank');
        },
        viewReplay(url) {
            window.open(url, '_blank');
        }
    }
};
